import { render } from "./upsell-minicart.vue?vue&type=template&id=05b89b0a"
import script from "./upsell-minicart.vue?vue&type=script&lang=js"
export * from "./upsell-minicart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Work/Sneak-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__